// extracted by mini-css-extract-plugin
export default {"setting":"setting_setting__Nczmw","title":"setting_title__qm2gC","version":"setting_version__iiicu"};